var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1635 15.6288V9.67499C11.1635 9.4776 11.0851 9.28831 10.9455 9.14874C10.806 9.00917 10.6167 8.93076 10.4193 8.93076H7.44235C7.24497 8.93076 7.05567 9.00917 6.9161 9.14874C6.77653 9.28831 6.69812 9.4776 6.69812 9.67499V15.6288",
    stroke: "#99A1AF",
    strokeWidth: 1.48846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23273 7.4423C2.23268 7.22578 2.27986 7.01186 2.371 6.81545C2.46213 6.61904 2.59502 6.44488 2.76039 6.30512L7.97 1.83973C8.23866 1.61267 8.57905 1.4881 8.9308 1.4881C9.28256 1.4881 9.62295 1.61267 9.89161 1.83973L15.1012 6.30512C15.2666 6.44488 15.3995 6.61904 15.4906 6.81545C15.5817 7.01186 15.6289 7.22578 15.6289 7.4423V14.1404C15.6289 14.5351 15.4721 14.9137 15.1929 15.1929C14.9138 15.472 14.5352 15.6288 14.1404 15.6288H3.72119C3.32642 15.6288 2.94783 15.472 2.66869 15.1929C2.38955 14.9137 2.23273 14.5351 2.23273 14.1404V7.4423Z",
    stroke: "#99A1AF",
    strokeWidth: 1.48846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8615,
    height: 17.8615,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.3455e66fa29940ca969f56a9495ec9db.svg";
export { ForwardRef as ReactComponent };